import React from 'react';
import { store } from '../../store';
import { createTheme } from '@mui/material/styles';
import { Provider as ReduxProvider } from 'react-redux';
import { ThemeProvider, CssBaseline } from '@mui/material';
import Router from './router';
import { useAuthInit } from '../../hooks/useAuthInit';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const theme = createTheme({
  palette: {
    primary: { main: '#1976d2' },
    secondary: { main: '#dc004e' },
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0,
      cacheTime: 0,
    },
  },
});

const AuthWrapper = () => {
  useAuthInit();
  return <Router />;
};

const App = () => {
  return (
    <ReduxProvider store={store}>
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <CssBaseline />
          <AuthWrapper />
        </QueryClientProvider>
      </ThemeProvider>
    </ReduxProvider>
  );
};

export default App;
